import { dataParser } from "src/common/dataParser";
import { ZUser, zUserSaveData } from "src/types/ZUser";

import { UserFormData, UserSaveData } from "../types";

export const userFormData2UserSaveData = (
  userFormData: UserFormData,
): UserSaveData => ({
  ...userFormData,
  roles:
    userFormData.roles?.map((role) => ({
      id: role,
    })) ?? [],
});

export const userSaveData2UserFormData = (sourceData: ZUser): UserFormData => {
  const saveData = dataParser(
    () => zUserSaveData.parse(sourceData),
    "User source data",
  );
  return {
    ...saveData,
    roles: saveData.roles?.map((role) => role.id) ?? [],
  };
};
